import React from "react";
import {useStyles} from "../styles/styles";
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Replay from "@mui/icons-material/Replay";
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {getDecimal} from "../global/utils";

const FeeList = (props) => {
    const fees = props.fees;
    const openFees = props.openFees;
    const setOpenFees = props.setOpenFees;
    const classes = useStyles;

    return (
        <Dialog
            disableEscapeKeyDown
            fullWidth
            maxWidth='md'
            open={openFees}
            onClose={() => setOpenFees(false)}
            sx={classes.dialog}
            aria-labelledby="View payment receipt"
        >
            <DialogTitle>
                <Typography variant="h6" component='h1' sx={classes.title}>Non-Case Fees</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Paper elevation={3} sx={{...classes.tableContainer, padding: '1rem', overflow: 'auto'}}>
                    <List sx={classes.list} >
                        <ListItem alignItems="flex-start" sx={classes.listPadding}>
                            <ListItemText
                                sx={classes.listText}
                                primary={
                                    <Grid
                                        container
                                        spacing={1}
                                        style={{width: '100%'}}
                                    >
                                        <Grid item xs={6} md={3}>Fee Name</Grid>
                                        <Grid item xs={6} md={2} sx={classes.valueRight}>Amount</Grid>
                                        <Grid item xs={6} md={2} sx={classes.valueRight}>Allow Amt. Entry</Grid>
                                        <Grid item xs={6} md={5} sx={{...classes.valueRight, textAlign: 'center'}}>Entry Instructions</Grid>
                                    </Grid>
                                }
                                primaryTypographyProps={{
                                    component: 'span',
                                    variant: 'subtitle1',
                                    sx: classes.inline,
                                    color: 'primary'
                                }}
                            />
                        </ListItem>
                        { fees && fees.map((fee) => {
                            return (
                                <>
                                    <ListItem alignItems="flex-start" divider sx={classes.listPadding}>
                                        <ListItemText
                                            sx={classes.listText}
                                            primary={
                                                <Grid
                                                    container
                                                    spacing={1}
                                                    style={{width: '100%'}}
                                                >
                                                    <Grid item xs={6} md={3}>{fee.name}</Grid>
                                                    <Grid item xs={6} md={2} sx={classes.valueRight}>{getDecimal(fee.amount)}</Grid>
                                                    <Grid item xs={6} md={2} sx={classes.valueRight}>{fee.allowAmountEntry ? 'Yes' : 'No'}</Grid>
                                                    <Grid item xs={6} md={5} sx={classes.value}>{fee.payorInstructions}</Grid>
                                                </Grid>
                                            }
                                            primaryTypographyProps={{
                                                component: 'span',
                                                variant: 'body2',
                                                sx: classes.inline,
                                                color: 'textPrimary'
                                            }}
                                        />
                                    </ListItem>
                                </>
                            );
                        })}
                    </List>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined"
                        color="primary"
                        startIcon={<Replay/>}
                        sx={classes.button}
                        onClick={() => setOpenFees(false)}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default FeeList;
